import { render, staticRenderFns } from "./MPago.vue?vue&type=template&id=9d7d42e0&scoped=true&"
import script from "./MPago.vue?vue&type=script&lang=js&"
export * from "./MPago.vue?vue&type=script&lang=js&"
import style0 from "./MPago.vue?vue&type=style&index=0&id=9d7d42e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7d42e0",
  null
  
)

component.options.__file = "MPago.vue"
export default component.exports